import axios from "axios";

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

// Helper to resolve image URL - handles all formats
export const resolveImageUrl = (url) => {
  if (!url) return "";
  
  // Static /images/ path - keep as-is (works on any domain)
  if (url.startsWith('/images/')) return url;
  
  // New uploads via /api/files/ - keep as-is (relative, works on any domain)
  if (url.startsWith('/api/files/')) return url;
  
  // External CDN URLs - keep as-is
  if (url.startsWith('http') && !url.includes('/api/uploads/')) return url;
  
  // Data URLs - keep as-is
  if (url.startsWith('data:')) return url;
  
  // Convert old /api/uploads/ URLs to /images/ paths (legacy fix)
  const match = url.match(/\/api\/uploads\/([a-f0-9-]+(?:\.\w+)?)/);
  if (match) {
    const filePart = match[1];
    return filePart.includes('.') ? `/images/${filePart}` : `/images/${filePart}.jpeg`;
  }
  
  return url;
};

// Configure axios to send cookies
axios.defaults.withCredentials = true;
